import { Credits } from './../Common/Credits/Credits'
import { GoToTop } from './../Common/GoToTop'
import { OfflineHeader } from './../Header/OfflineHeader'


const PrivacyNotice = () => {
    return (
        <>
            <OfflineHeader />

            <main className='container'>
                <h1 className='text-center fs-3 mt-5'>Aviso de privacidad</h1>
                
                <p>Con fundamento en los artículos 15 y 16 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, hacemos de su conocimiento que FIVE DIGITAL MINDS, con domicilio en Calle Fuete 307, Fraccionamiento Parque Herradura, C.P. 78394, Villa de Pozos, San Luis Potosí, México, es responsable de recabar sus datos personales, del uso que se les dé y de su protección.</p>


                <h2 className='fs-3 mt-5'>1. Finalidades del tratamiento de datos personales</h2>

                <p>La información personal que recabamos será utilizada para las siguientes finalidades:</p>
                <ul>
                    <li>Proveer los servicios y productos solicitados relacionados con nuestras soluciones tecnológicas educativas.</li>
                    <li>Notificarle sobre nuevos servicios o productos que tengan relación con los ya contratados.</li>
                    <li>Comunicarle cambios en nuestros servicios.</li>
                    <li>Brindar soporte técnico y atención personalizada.</li>
                    <li>Procesar pagos y facturación.</li>
                    <li>Enviar promociones, contenidos educativos y comunicaciones relevantes.</li>
                    <li>Evaluar la calidad de nuestros servicios y mejorar continuamente nuestras soluciones.</li>
                </ul>


                <h2 className='fs-3 mt-4'>2. Datos personales que recabamos</h2>

                <p>Para cumplir con las finalidades antes mencionadas, podemos recabar los siguientes datos personales:</p>
                <ul>
                    <li>Nombre completo</li>
                    <li>Apellidos</li>
                    <li>Correo electrónico</li>
                </ul>
                <p>Opcionalmente:</p>
                <ul>
                    <li>Número telefónico</li>
                    <li>Datos fiscales</li>
                    <li>Datos bancarios (no recabados directamente desde el sitio web)</li>
                </ul>
                <p>No recabamos datos personales sensibles.</p>


                <h2 className='fs-3 mt-4'>3. Transferencia de datos</h2>

                <p>FIVE DIGITAL MINDS no comparte sus datos personales con terceros, ni realiza transferencias internacionales de datos. El tratamiento de los datos se realiza exclusivamente por personal autorizado de nuestra empresa.</p>
            

                <h2 className='fs-3 mt-4'>4. Derechos ARCO</h2>

                <p>Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales (derechos ARCO), así como a revocar el consentimiento que nos haya otorgado.</p>
                <p>Para ejercer estos derechos, deberá enviar una solicitud conforme al artículo 29 de la Ley, al correo electrónico: <a href='mailto:contacto@fivedigitalminds.com'>contacto@fivedigitalminds.com</a>. Le recomendamos confirmar la recepción de su solicitud vía telefónica para garantizar su atención.</p>


                <h2 className='fs-3 mt-4'>5. Medidas de seguridad</h2>

                <p>FIVE DIGITAL MINDS adopta medidas de seguridad administrativas, técnicas y físicas para proteger sus datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado.</p>
                

                <h2 className='fs-3 mt-4'>6. Cambios al aviso de privacidad</h2>

                <p>Este aviso de privacidad puede ser modificado o actualizado en cualquier momento. Las modificaciones estarán disponibles en nuestro sitio web.</p>

                <p className='mt-5'>Fecha de última actualización: 31/10/2025</p>
            </main>

            <Credits />

            <GoToTop />
        </>
    )
}

export { PrivacyNotice };